const getWindowOrigin = () => {
  if (typeof window === 'undefined') {
    return 'http://localhost:4200';
  }

  return window.location.origin;
};

export const AUTH_SESSION_KEY = 'pmm_auth_session';
export const AUTH_PROXY_BASE_URL = process.env.REACT_APP_AUTH_PROXY_URL || 'https://localhost:8085';
export const AUTH_LOGIN_URL = `${AUTH_PROXY_BASE_URL}/auth/login`;
export const AUTH_LOGOUT_URL = `${AUTH_PROXY_BASE_URL}/logout`;
export const FRONTEND_REDIRECT_URL = process.env.REACT_APP_AUTH_RETURN_URL || `${getWindowOrigin()}/pmm/`;

export function buildAuthLoginUrl(returnTo = FRONTEND_REDIRECT_URL) {
  return `${AUTH_LOGIN_URL}?returnTo=${encodeURIComponent(returnTo)}`;
}

export function buildAuthLogoutUrl(returnTo = FRONTEND_REDIRECT_URL) {
  return `${AUTH_LOGOUT_URL}?returnTo=${encodeURIComponent(returnTo)}`;
}

const authConfig = {
  AUTH_SESSION_KEY,
  AUTH_PROXY_BASE_URL,
  AUTH_LOGIN_URL,
  AUTH_LOGOUT_URL,
  FRONTEND_REDIRECT_URL,
};

export default authConfig;
